Registrable = require 'mixins/registrable'

App.OrderStatusMiniPopupComponent = Em.Component.extend Registrable,
  env: Em.inject.service('environment')
  session: Em.inject.service('session')
  notifier: Em.inject.service()

  classNames: [ 'order-status-mini-popup' ]

  selectedStatus: Em.computed.oneWay('order.status')

  isPendingCurrent:   Em.computed.equal('order.status', 'pending')
  isConfirmCurrent:   Em.computed.equal('order.status', 'confirm')
  isPreparingCurrent: Em.computed.equal('order.status', 'preparing')
  isPreparedCurrent:  Em.computed.equal('order.status', 'prepared')
  isDeliveryCurrent:  Em.computed.equal('order.status', 'delivery')
  isCompleteCurrent:  Em.computed.equal('order.status', 'complete')
  isUndoCurrent:      Em.computed.equal('order.status', 'undo')


  selectedCancelReason: null
  cancelReasons: Em.computed.alias('env.features.orderCancelReasons')

  cancelReason: null
  cancelReasonComment: null

  lastCancelReasonSelected: (->
    return false unless @get('cancelReasons')
    @get('cancelReasons')[@get('cancelReasons').length - 1] == @get('selectedCancelReason')
  ).property('selectedCancelReason','cancelReasons')

  showCancelReasonField: (->
    return false unless @get('cancelReasons') && @get('selectedStatus') == 'undo'
    true
  ).property('selectedStatus', 'cancelReasons', 'lastCancelReasonSelected')

  orderCancelCommentEnabled: Em.computed.alias('env.features.orderCancelCommentEnabled')

  showCancelReasonCommentField: (->
    return false unless @get('orderCancelCommentEnabled')
    @get('showCancelReasonField') && @get('lastCancelReasonSelected')
  ).property('selectedStatus', 'cancelReasons', 'lastCancelReasonSelected','orderCancelCommentEnabled')




  showSmsToggle: (->
    @get('selectedStatus') in [ 'confirm', 'undo' ] and !@get('order.client_notification_type_call')
  ).property('selectedStatus')

  disabledSmsToggle: (->
    @get('selectedStatus') == 'undo' and !@get('session.accessRights.canMuteCancelSms')
  ).property('selectedStatus','session.accessRights.canMuteCancelSms')

  showCallWarning: (->
    @get('selectedStatus') in [ 'confirm', 'undo' ] and @get('order.client_notification_type_call')
  ).property('selectedStatus')

  dontSendSmsMessage: (->
    switch @get('selectedStatus')
      when 'confirm'
        @get('env').translate('status_mini_popup.confirm_sms_hint')
      when 'undo'
        @get('env').translate('status_mini_popup.cancel_sms_hint')
  ).property('env', 'selectedStatus')

  sendClientSms: true

  isLoading: false

  actions:
    changeSelectedCancelReason: (reason) ->
      @set('selectedCancelReason', reason)
      unless @get('lastCancelReasonSelected')
        @set('cancelReason', reason)
      else
        @set('cancelReasonComment', '')
      false

    pickStatus: (status) ->
      @set('selectedStatus', status)
      false

    openHistory: ->
      @get('popups').send('openPopup', 'history-popup')
      false

    changeStatus: ->
      return if @get('isLoading')

      order = @get('order')
      @set('isLoading', true)

      opts = {}
      if !@get('sendClientSms')
        opts.mute = [ 'client_sms' ]

      if @get('cancelReason')
        opts.cancel_reason = @get('cancelReason')
        opts.cancel_reason_comment = if @get('lastCancelReasonSelected') then @get('cancelReasonComment') else ''

      order.changeStatus(@get('selectedStatus'), opts)
      .catch (e) =>
        order.rollback()
        error_message = e.responseJSON?.error
        @get('notifier').pushNotification
          type: 'error'
          # todo i18n
          title: 'Статус не может быть установлен.'
          message: error_message
          duration: 30000
      .finally =>
        @get('popups').send?('closePopup')
        @set('isLoading', false)
      false
